module.exports = __webpack_public_path__ + "img/all-zones-inactive.f5b58b5a.svg";